import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import ActionItemCard
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MessagesActionItemCard';

const useStyles = buildUseStyles('MessageSkeleton', (theme) => ({
  root: {
    marginRight: theme.spacing(1),
  },
}));

const TaskBody = ({
  actionItem,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <ActionItemCard className={classes.root} actionItem={actionItem} />
  );
};

TaskBody.propTypes = {
  actionItem: PropTypes.object.isRequired,
};


export default TaskBody;
